import I18N_FORMAT_MAP from '@rover/constants/src/i18n/i18nFormatMap.constants';
import { Locale } from '@rover/constants/src/i18n/lingui.constants';
import { DEFAULT_LOCALE } from '@rover/constants/src/i18n/locale';
import type { LocalizedFormatFunction } from '@rover/types/src/LocalizedFormatFunction';

import generateExternalFormatMap from './generateExternalFormatMap';

function generateFormatMap(
  getLocalizedFormat: LocalizedFormatFunction,
  locale?: Locale
): Record<string, string> {
  return Object.keys(I18N_FORMAT_MAP[DEFAULT_LOCALE]).reduce((acc, key) => {
    acc[key] = getLocalizedFormat(key, locale);
    return acc;
  }, generateExternalFormatMap(getLocalizedFormat, locale));
}
export default generateFormatMap;
